/*
 * @Author: Eugene
 * @Date: 2020-04-26 21:33:17
 * @Last Modified by: Eugene
 * @Last Modified time: 2020-04-28 16:37:57
 */

import React, { useEffect, useState } from 'react';
import { connect } from 'umi';
import { Card, Row, Col, Form, Tooltip, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';

import moment from 'moment';

const FormItem = Form.Item;

const colLayout = {
  xs: { span: 24 }, // phone
  sm: { span: 12 }, // pad
  md: { span: 24 }, // pc
};

const modalFormItem = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 },
  style: { marginBottom: 12 },
};

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  style: { marginBottom: 12 },
};

const Deatil = (props) => {
  const initData = () => {
    const {
      dispatch,
      location: { query },
    } = props;
    dispatch({
      type: 'liveState/fetchData',
      payload: {
        requestData: query.id,
      },
    });
  };

  const {
    liveState: { data },
  } = props;

  useEffect(() => {
    initData();
  }, []);

  return (
    <PageContainer>
      <Card bordered={false}>
        {data.classDto ? (
          <Row>
            <Col {...colLayout}>
              <FormItem
                {...modalFormItem}
                label={<span style={{ fontSize: 18 }}>课程信息</span>}
                colon={false}
              />
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="课程名称">
                {data.classDto.title}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="直播计划时间">
                {moment
                  .unix(data.classDto.liveStartTime)
                  .format('YYYY-MM-DD HH:mm:ss')}{' '}
                ~ {moment.unix(data.classDto.liveEndTime).format('HH:mm:ss')}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              {data.liveActualStartTime && data.liveActualEndTime ? (
                <FormItem {...modalFormItem} label="直播实际时间">
                  {moment(data.liveActualStartTime).format(
                    'YYYY-MM-DD HH:mm:ss',
                  )}{' '}
                  ~ {moment(data.liveActualEndTime).format('HH:mm:ss')}
                </FormItem>
              ) : (
                <FormItem {...modalFormItem} label="直播实际时间">
                  无
                </FormItem>
              )}
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="教练">
                {data.classDto.showCoachName}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="直播用账号">
                {data.classDto.coachAccountName}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem
                {...modalFormItem}
                label={<span style={{ fontSize: 18 }}>数据概况</span>}
                colon={false}
              >
                <Tooltip
                  style={{ width: 400 }}
                  title={
                    <ul>
                      <li>
                        ·
                        直播时长：实际有效直播的时长，例如中断的直播时间不算在内
                      </li>
                      <li>
                        · 直播时观看人次（PV）：直播期间用户进入直播间的次数
                      </li>
                      <li>
                        · 直播时观看人数（UV）：直播期间进入直播间的用户数量
                      </li>
                      <li>
                        ·
                        最高同时在线人数（UV）：直播期间同时在直播间的用户数量，按分钟
                      </li>
                      <li>
                        ·
                        直播新用户数（UV）：直播期间，这个视频是他第一次观看团课直播的用户数量
                      </li>
                      <li>· 累计观看人次（PV）：累计用户进入直播间的次数</li>
                      <li>· 累计观看人数（UV）：累计进入直播间的用户数量</li>
                    </ul>
                  }
                >
                  <InfoCircleOutlined
                    style={{ color: '#f1d04c', fontSize: 14 }}
                  />
                </Tooltip>
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem
                {...modalFormItem}
                label={<span style={{ fontSize: 14 }}>直播数据</span>}
                colon={false}
              />
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="直播时长">
                {data.duration}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="直播时观看人次（PV）">
                {data.pv}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="直播时观看人数（UV）">
                {data.uv}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="最高同时在线人数（UV）">
                {data.peakConcurrentNum}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="直播新用户数（UV）">
                {data.newUserNum}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem
                {...modalFormItem}
                label={<span style={{ fontSize: 14 }}>累计数据</span>}
                colon={false}
              />
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="累计观看人次（PV）">
                {data.totalPv}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label="累计观看人数（UV）">
                {data.totalUv}
              </FormItem>
            </Col>
            <Col {...colLayout}>
              <FormItem {...modalFormItem} label={<span />} colon={false}>
                <Button onClick={() => history.back()}>返回</Button>
              </FormItem>
            </Col>
          </Row>
        ) : null}
      </Card>
    </PageContainer>
  );
};

function mapStateToProps({ liveState, loading }) {
  return {
    liveState,
    loading: loading.effects['liveState/fetchData'],
  };
}

export default connect(mapStateToProps)(Deatil);
